import { Component, Input, OnChanges } from '@angular/core';

import { IRequestQuestionChoice } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'choices-msg',
  templateUrl: './choices-msg.component.html',
  styleUrls: ['./choices-msg.component.scss']
})
export class ChoicesMsgComponent implements OnChanges {
  @Input() questionTitle: string;
  @Input() choices: IRequestQuestionChoice[];

  public choicesStr = '';

  ngOnChanges() {
    this.choicesStr = (this.choices || [])
      .map((choice) => choice && choice.name)
      .filter(Boolean)
      .join(', ');
  }

}
